import { DEFAULT_PORTS_BRAND } from "../../assets/consts";

export type ServerInfoType = {
  serverId: string;
  publicAddress: string | null;
  localAddress: string | null;
  accessToken: string | null;
  userFullName: string;
  userId: string;
  ports: PortsType;
};
export type PortsType = {
  http: number | null;
  https: number | null;
  ws: number | null;
  wss: number | null;
};
export default class ServerInfo {
  serverId: string;
  publicAddress: string | null;
  localAddress: string | null;
  accessToken: string | null;
  userFullName: string;
  userId: string;
  ports: PortsType;

  constructor(
    serverId: string,
    publicAddress: string | null,
    localAddress: string | null,
    accessToken: string | null,
    userFullName: string,
    userId: string,
    ports: PortsType = DEFAULT_PORTS_BRAND
  ) {
    this.serverId = serverId;
    this.publicAddress = publicAddress;
    this.localAddress = localAddress;
    this.accessToken = accessToken;
    this.userFullName = userFullName;
    this.userId = userId;
    this.ports = ports;
  }

  static parse(obj: ServerInfo) {
    var result: any = new ServerInfo("", "", "", "", "", "", {
      http: 3030,
      https: 3032,
      ws: 3031,
      wss: 3033,
    });
    Object.assign(result, obj);
    return result;
  }
}
